import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CBadge, CCard, CCardBody } from '@coreui/react-pro';

import { formatEventMultiDate, formatEventTime, getLocationLinkEvent } from '../../../../../../utils';
import { LOCATION_TYPE, ORDER_STATUS } from '../../../../../../constants';
import images from '../../../../../../assets/images';

const YourEventCard = ({ event, linkToDetail }) => {
     const [isShown, setIsShown] = useState(false);

     const isSchedule = event.startAt && event.endAt && event.timezone ? true : false;

     return (
          <CCard className="timeline-training">
               <CCardBody>
                    {event?.publishName && <h3 className="text-center">{event?.publishName}</h3>}

                    <div className="time-training-events">
                         <span>Date:</span>
                         <p>{isSchedule ? formatEventMultiDate(event.startAt, event.endAt) : 'Unschedule'}</p>
                    </div>
                    <div className="time-training-events">
                         <span>Time:</span>
                         <p>{isSchedule ? formatEventTime(event.startAt, event.endAt) : 'Unschedule'}</p>
                    </div>
                    <div className="time-training-events">
                         <span>Location:</span>
                         {!isSchedule && <p>Unschedule</p>}
                         {event?.location &&
                              (event.locationType === LOCATION_TYPE.ONLINE ? (
                                   <a href={getLocationLinkEvent(event.location)} target="_blank" rel="noreferrer">
                                        {event.location}
                                   </a>
                              ) : (
                                   <p>{event.location}</p>
                              ))}
                    </div>

                    {event.locationType === LOCATION_TYPE.IN_PERSON && (
                         <div className="time-training-events">
                              <span>Notes:</span>
                              <p>{event.locationNotes || ''}</p>
                         </div>
                    )}

                    <div className="events-status">
                         <CBadge
                              className={
                                   event?.course?.courseStatus === ORDER_STATUS.COMPLETED
                                        ? 'badge-pill badge-outline-success'
                                        : 'badge-pill badge-outline-primary'
                              }
                         >
                              {event.course?.courseStatus}
                         </CBadge>
                         <div className="view-details-events" onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>
                              <Link className="btn btn-outline-none-primary btn-details" to={linkToDetail}>
                                   VIEW DETAILS
                              </Link>
                              <Link to={linkToDetail} onMouseEnter={() => setIsShown(true)}>
                                   {isShown ? <img src={images.arrowBlueHighlight} alt="" /> : <img src={images.Group2} alt="" />}
                              </Link>
                         </div>
                    </div>
               </CCardBody>
          </CCard>
     );
};

export default YourEventCard;
